import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Button } from 'grab-ui';
import {
  SCRIBE_SHOPIFY_STATES,
  SCRIBE_SHOPIFY_EVENTS,
} from 'applications/scribe/instrumentations/track';
import ShopifyTrackEventContext from 'views/v2/shopify-home/track-event';
import { ROUTES_V2_PATHS } from 'constants/route-constants';
import PageContentPanel from 'components/v2/page-content-panel';
import Logo from 'public/images/shopify-x-grabexpress.png';
import Search from '../shopify-orders/search';
import styles from './shopify-new.less';

const localeKeyPrefix = 'shopify.new';

const ShopifyNew = ({ history }) => {
  const trackCtx = React.useContext(ShopifyTrackEventContext);

  const fireDefaultUnlinkedPageTrackEvent = () => {
    trackCtx.fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_ORDERS_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.DEFAULT_UNLINKED,
    });
  };

  const fireLinkUrlTrackEvent = () => {
    trackCtx.fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_ORDERS_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.LINK_URL,
    });
  };

  const fireLearnMoreTrackEvent = () => {
    trackCtx.fireShopifyTrackEvent({
      stateName: SCRIBE_SHOPIFY_STATES.EXPRESS_SHOPIFY_ORDERS_WEB,
      eventName: SCRIBE_SHOPIFY_EVENTS.LEARN_MORE,
    });
  };

  const linkUrlHandler = () => {
    fireLinkUrlTrackEvent();
    history.push(ROUTES_V2_PATHS.shopifyLink);
  };

  const learnMoreHandler = () => {
    fireLearnMoreTrackEvent();
  };

  React.useEffect(() => {
    fireDefaultUnlinkedPageTrackEvent();
  }, []);

  return (
    <div className={styles.ShopifyNew}>
      {/* for aesthetics only */}
      <Search onSearchChange={() => {}} />
      <PageContentPanel>
        <div className={styles.ContentWrapper}>
          <img
            className={styles.Logo}
            src={Logo}
            alt={'Shopify X Express Logo'}
          />
          <div className={styles.Heading}>
            {I18n.t(`${localeKeyPrefix}.heading`)}
          </div>
          <div className={styles.Description}>
            {I18n.t(`${localeKeyPrefix}.description`)}
          </div>
          <div>
            <Button
              className={styles.LinkUrlButton}
              type="primary"
              size={'large'}
              onClick={linkUrlHandler}
            >
              {I18n.t(`${localeKeyPrefix}.buttonLabels.linkUrl`)}
            </Button>
          </div>
          <div>
            <Button
              className={styles.LearnMoreButton}
              type="link"
              size={'large'}
              onClick={learnMoreHandler}
            >
              {I18n.t(`${localeKeyPrefix}.buttonLabels.learnMore`)}
            </Button>
          </div>
        </div>
      </PageContentPanel>
    </div>
  );
};

ShopifyNew.propTypes = {
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(ShopifyNew);
